"use client";

import { useEffect } from "react";
import { mixpanelV1Client } from "services/mixpanel";
import { EventENUM, EventENUMV2 } from "services/mixpanel/types";
import { mixpanelV2Client } from "services/mixpanelv2";
import { setDetailPageOrigin } from "utils/local-storage";
const handleV1Event = (eventName: string, props: string | null) => {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-call
  mixpanelV1Client[eventName](props ? JSON.parse(props) : {});
};
const handleV2Event = (eventName: string, props: string | null) => {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-call
  mixpanelV2Client[eventName](props ? JSON.parse(props) : {});
};
const handleSearchOriginEvents = (e: MouseEvent) => {
  const searchOriginEl = (e.target as HTMLElement).closest("[data-track-search-origin]");
  if (!searchOriginEl) {
    return;
  }
  const searchOrigin = searchOriginEl.getAttribute("data-track-search-origin");
  if (!searchOrigin) {
    return;
  }
  localStorage.setItem("searchPageOrigin", searchOrigin);
};
const handleDetailOriginEvents = (e: MouseEvent) => {
  const detailOriginEl = (e.target as HTMLElement).closest("[data-track-detail-origin]");
  if (!detailOriginEl) {
    return;
  }
  const detailOrigin = detailOriginEl.getAttribute("data-track-detail-origin");
  if (!detailOrigin) {
    return;
  }
  setDetailPageOrigin(detailOrigin);
};
const GlobalClickTracker = () => {
  useEffect(() => {
    const handleClick = (e: MouseEvent) => {
      const el = (e.target as HTMLElement).closest("[data-track-v2-event],[data-track-v1-event]");
      if (el) {
        const eventNameV1 = el.getAttribute("data-track-v1-event");
        const eventNameV2 = el.getAttribute("data-track-v2-event");
        if (eventNameV1) {
          const props = el.getAttribute("data-track-v1-props");
          const eventName = eventNameV1;
          if (eventName && EventENUM[eventName]) {
            setTimeout(() => {
              handleV1Event(eventName, props);
            }, 0);
          }
        }
        if (eventNameV2) {
          const props = el.getAttribute("data-track-v2-props");
          const eventName = eventNameV2;
          if (eventName && EventENUMV2[eventName]) {
            setTimeout(() => {
              handleV2Event(eventName, props);
            }, 0);
          }
        }
      }
      try {
        handleSearchOriginEvents(e);
      } catch (error) {
        console.error("Error in handleSearchOriginEvents", error);
      }
      try {
        handleDetailOriginEvents(e);
      } catch (error) {
        console.error("Error in handleDetailOriginEvents", error);
      }
    };
    document.addEventListener("click", handleClick);
    return () => document.removeEventListener("click", handleClick);
  }, []);
  return null;
};
export default GlobalClickTracker;